export default __webpack_public_path__ + "static/media/step-six.cff6e521.png";